<template>
  <div
    v-if="checkupStore.csvExports.length"
    class="tw-flex tw-flex-col tw-gap-1"
  >
    <p class="tw-font-semibold tw-text-lg">
      <i class="tw-mr-1 fas fa-table" />
      Spreadsheets to download
    </p>
    <a
      v-for="file in checkupStore.csvExports"
      :key="file?.filename"
      :href="file?.url"
      :download="file?.filename"
      class="tw-text-sm"
    >
      Spreadsheet for {{ file?.filename }}
    </a>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';
import { mapStores } from 'pinia';

export default {
  name: 'SpreadsheetLinks',
  components: { /* Subcomponents */ },
  props: [/* Inputs */],
  data() {
    return { /* Local variables */ };
  },
  computed: { /*
      Creates a new property
      Updates when any dependant property changes */
    ...mapStores(useCheckupStore),
  },
  watch: { /*
      Watches an existing property
      Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>


  <style scoped>

  </style>
